// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var JsxRuntime = require("react/jsx-runtime");
var AuthenticatedComponentRelay = require("./AuthenticatedComponentRelay.bs.js");

function RequireAuthenticatedClient(props) {
  var children = props.children;
  return JsxRuntime.jsx(AuthenticatedComponentRelay.make, {
              requiredUserRole: "client",
              renderWrappedComponent: (function () {
                  return children;
                })
            });
}

var make = RequireAuthenticatedClient;

exports.make = make;
/* react/jsx-runtime Not a pure module */
